export default "__VITE_ASSET__DRbVuFQ9__"